import {
  TextField,
  MenuItem,
  Chip,
  Box,
  Checkbox,
  ListItemText,
} from '@mui/material';
import React from 'react';
import { StyledPlaceholder } from './index.style';

const CustomMultiSelect = ({
  className = '',
  placeholder = 'Select options...',
  label = '',
  options = [],
  value = [],
  onChange,
  helperText,
  error,
  disabled,
  fullWidth = true,
}) => {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    if (onChange) {
      onChange(
        typeof selectedValue === 'string'
          ? selectedValue.split(',')
          : selectedValue,
      );
    }
  };

  const renderValue = (selected) => {
    if (!selected || selected.length === 0) {
      return <StyledPlaceholder>{placeholder}</StyledPlaceholder>;
    }

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selected.map((selectedValue) => {
          const item = options.find((option) => option.value === selectedValue);
          return (
            <Chip
              key={selectedValue}
              label={item?.label || selectedValue}
              size="small"
              sx={{
                height: 24,
                fontSize: '0.75rem',
                '& .MuiChip-label': {
                  padding: '0 8px',
                },
              }}
            />
          );
        })}
      </Box>
    );
  };

  return (
    <TextField
      className={className}
      size="small"
      variant="outlined"
      select
      fullWidth={fullWidth}
      disabled={disabled}
      value={value}
      SelectProps={{
        multiple: true,
        displayEmpty: true,
        renderValue,
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 48 * 4.5 + 8,
              width: 250,
            },
          },
        },
      }}
      onChange={handleChange}
      error={error}
      helperText={helperText}
      label={label}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <Checkbox checked={value.indexOf(option.value) > -1} />
          <ListItemText primary={option.label} />
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CustomMultiSelect;
